import { API_URL, fetchOptions, parseJSONContent } from 'store/fetchUtils'

const useNotificationService = () => {
	const markAsRead = (notificationId) => {
		return fetch(
			`${API_URL}/api/notifications/${notificationId}`,
			fetchOptions({
				method: 'PUT',
				body: { isRead: true, closed: false },
			})
		)
			.then((r) => parseJSONContent(r))
			.catch(() => null)
	}
	const markAsUnread = (notificationId) => {
		return fetch(
			`${API_URL}/api/notifications/${notificationId}`,
			fetchOptions({
				method: 'PUT',
				body: { isRead: false, closed: false },
			})
		)
			.then((r) => parseJSONContent(r))
			.catch(() => null)
	}

	const markAsClosed = (notificationId) => {
		return fetch(
			`${API_URL}/api/notifications/${notificationId}`,
			fetchOptions({
				method: 'PUT',
				body: { isRead: true, closed: true },
			})
		)
			.then((r) => parseJSONContent(r))
			.catch(() => null)
	}
	return { markAsRead, markAsUnread, markAsClosed }
}

export default useNotificationService
